import { MessageBar, MessageBarType, Spinner, Stack } from "@fluentui/react";
import React from "react";
import { ValidationResult } from "sprint-common-web";

interface DeleteIntegratorValidationSummaryProps {
    validationResult: ValidationResult | undefined;
    isValidating?: boolean;
}

export const DeleteIntegratorValidationSummary: React.FC<DeleteIntegratorValidationSummaryProps> = ({
    validationResult,
    isValidating
}: DeleteIntegratorValidationSummaryProps) => {
    const failures = validationResult?.failures ?? [];

    return (
        <Stack
            styles={{
                root: { padding: 10 }
            }}
        >
            {isValidating && <Spinner />}
            {!isValidating && (
                <>
                    {failures.map((item) => (
                        <MessageBar key={item.code} messageBarType={MessageBarType.warning}>
                            {
                                <>
                                    {item.message}
                                    <br />
                                </>
                            }
                        </MessageBar>
                    ))}
                </>
            )}
        </Stack>
    );
};
